import {
	gsap
} from "gsap/dist/gsap";
import {
	ScrollTrigger
} from "gsap/dist/ScrollTrigger";
import {
	ScrollToPlugin
} from "gsap/dist/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);


const mainContent = document.getElementById('site');
const preLoaderEl = document.querySelector('.preloader');
const headerBar = mainContent.querySelector('#masthead');


var headerBarAnimate = gsap.timeline({
	paused: true, // default is false
	smoothChildTiming: true,
});
headerBarAnimate
    .fromTo(
        headerBar, {
            opacity: 0,
			scale: 0.95
        }, {
            opacity: 1,
			scale: 1,
            duration: 0.5,
        });

const pageTitleWrapper = mainContent.querySelector('.page-title');;
var pageHeaderAnimate = gsap.timeline({
	paused: true, // default is false
	smoothChildTiming: true,
});
pageHeaderAnimate
	.fromTo(
		pageTitleWrapper.querySelector('h1'), {
			opacity: 0,
			scale: 0.9,
			y: "+=35"
		}, {
			opacity: 1,
			scale: 1,
			y: 0,
			duration: 0.8,
			// delay: .5
		}
	)
	.fromTo('.custom-title-desc ',
		{
				opacity: 0,
				scale: 0.9
			}, {
				opacity: 1,
				scale: 1,
				duration: 1
			}, '<.1	'
		)
		


// var pageSubTitleAnimate = gsap.timeline(
// 	{
// 		paused: true, // default is false
// 		smoothChildTiming: true,
// 	}
// );
// pageSubTitleAnimate
// 	.fromTo(
// 		pageSubTitle,
// 		{
// 				opacity: 0
// 			}, {
// 				opacity: 1,
// 				duration: 0.5
// 			}, '0.1'
// 		)
// 		.fromTo(
// 			pageSubTitle,
// 			{
// 				scale: 0.9
// 			}, {
// 				scale: 1,
// 				duration: 1
// 			},
// 		)
	


// cardAnimate
// 	.fromTo(".howWeWork-card-wrapper", {
// 		opacity: 0,
// 		y: '50px',
// 	}, {
// 		opacity: 1,
// 		y: '0px',
// 		duration: 0.5,
// 		stagger: 0.1,
// 	},'0.1')
// 	.fromTo(".howWeWork-card-wrapper .card-info__content .title-card-info-content", {
// 		scale: 1.1,
// 	}, {
// 		scale: 1,
// 		duration: 1,
// 	}, '0.1');




// .fromTo(
// 	'.howWeWork-card-wrapper',
// 	{
// 		y: '0px'
// 	},
// 	{
// 		y: '0px',
// 		stagger: 0.1,
// 		duration: 0.5,
// });
	



const sectionCapabilities = document.querySelector('.section-capabilities');
var sectionCapabilitiesAnimate = gsap.timeline(
	{
		paused:false,
		smoothChildTiming:true,
		scrollTrigger:{
			trigger:sectionCapabilities.querySelector("h2"),
			// markers: true,
			start: "top center",
			end: "bottom center",
		}
	}
);
sectionCapabilitiesAnimate
	.fromTo(
		sectionCapabilities.querySelector("h2"),
		{
			opacity:0
		},
		{
			opacity: 1,
			duration: 0.5
		}
	)
	.fromTo(
		sectionCapabilities.querySelector("h2"),
		{
			scale:1.2
		},
		{
			scale:1,
			duration:1
		},
		".2"
	)
sectionCapabilitiesAnimate.addLabel("section-capabilities");


var cards = document.querySelectorAll('.capability-content.capability-content__item');
cards.forEach(function (card) {
	var titleCapability = card.querySelector('.title-capabilities');
	var textCapability = card.querySelector('.text-capabilities');
	
	var contentCapability = card.querySelectorAll('.detail-capabilities');
	var buttonCapability = card.querySelectorAll('.btn-see-design');

	var cardAnimation = gsap.timeline({
		paused: false,
		smoothChildTiming: true,
		scrollTrigger: {
			trigger: card,
			start: "top center",
			end: "bottom bottom",
			// markers: true
		},
		defaults: {
			duration: .3,
		},
	});
	
	cardAnimation
	.fromTo(
		card,
		{
			opacity: 0
		},
		{
			opacity: 1,
			duration: .3
		}
	)
	cardAnimation
	.fromTo(
		card.querySelector('img.imageServices'),
		{
			opacity: 0.9
		},
		{
			opacity: 1,
			duration: 0.3
		},
		".1"
	)
	.fromTo(
		card.querySelector('img.imageServices'),
		{
		
			y:'50px'
		},
		{
			
			y:'0px',
			duration:.4
		},
		".1"
	)

	cardAnimation.fromTo(titleCapability, {
		opacity: 0
	}, {
		opacity: 1,
	}, "<0.1");
	cardAnimation.fromTo(titleCapability, {
		scale: 1.1
	}, {
		scale: 1,
		duration: 0.8
	}, "<0.1");

	cardAnimation.fromTo(textCapability, {
		opacity: 0
	}, {
		opacity: 1,
	}, "<.1");
	cardAnimation.fromTo(textCapability, {
		scale: 1.1
	}, {
		scale: 1,
		duration: 0.8
	}, "<0");

	// cardAnimation.fromTo(contentCapability, {
		
	// }, {
		
	// 	duration: .5
	// }, "0.15");
	cardAnimation.fromTo(contentCapability, {
		y: '50px',
		opacity: 0
	}, {
		y: '0px',
		opacity: 1,
		stagger: .2,
		duration:0.8
	}, "<.15");

	cardAnimation.fromTo(buttonCapability, {
		opacity: 0
	}, {
		opacity: 1,
	}, "<0.2");
	cardAnimation.fromTo(buttonCapability, {
		y: '50px',
	}, {
		y: '0px',
		duration: 1
	}, "<0.1");
});
let timelineOurWorks = gsap.timeline({
  scrollTrigger:{
    trigger:'.feature-work__wrapper',
    start: 'top 80%'
  },
	paused: false, // default is false
	smoothChildTiming: true,
});

timelineOurWorks
.fromTo('.our-work__portofolio figure',{
  width:'75%',
  duration:1,

},{
  width:'100%',
  stagger:.2
},'<.1')
.fromTo('.our-work__portofolio figure img',{
  scale:1.2
},{
  duration:1,
  scale:1,
  stagger:.2
},'-=1');


document.addEventListener("DOMContentLoaded", function () {
	if (preLoaderEl) {
		setTimeout(function () {
			preLoaderEl.classList.add('hide');
			mainContent.classList.remove('overflow-hidden');
			mainContent.classList.remove('opacity-0');
			mainContent.classList.add('opacity-100');
		
			window.scroll({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});
			
		}, 1300)
	
		
	
		
	}
	setTimeout(() => {
		headerBarAnimate.play();
		pageHeaderAnimate.play();
		// cardAnimate.play();
	
		const hwwCard = document.querySelectorAll('.howWeWork-card-wrapper');
		if (window.innerWidth <= 768) {
			hwwCard.forEach(card => {
			  let imgCard = card.querySelector('.imageCard');
			  let titleCard = card.querySelector('.title-card-info-content');
		  
			  let cardAnimate = gsap.timeline({
				scrollTrigger: {
				  trigger: card,
				  start: "top center"
				},
				smoothChildTiming: true,
			  });
			  cardAnimate.eventCallback("onComplete", function () {
				hwwCard.forEach(function (card) {
					card.classList.add('duration-500');
				});
			  });
			  cardAnimate
				.fromTo(card, {
				  opacity: 0,
				  y: '40px',
				}, {
				  y: '0px',
				  opacity: 1,
				  duration: 0.8,
				  stagger: 0.2,
				})
				.fromTo(imgCard, {
				  scale: 1.1,
				  duration: 1,
				}, {
				  scale: 1,
				}, '<.1')
				.fromTo(titleCard, {
				  scale: 1.1,
				  duration: 1,
				}, {
				  scale: 1,
				}, '<.1');
			});
		  } else {
			let imgCards = document.querySelectorAll('.imageCard');
			let titleCards = document.querySelectorAll('.title-card-info-content');
		  
			let cardAnimate = gsap.timeline({
			  scrollTrigger: {
				trigger: '.howWeWork-card-wrapper',
				start: "top center"
			  },
			  smoothChildTiming: true,
			});
			cardAnimate.eventCallback("onComplete", function () {
				hwwCard.forEach(function (card) {
					card.classList.add('duration-500');
				});
			  });
			cardAnimate
			  .fromTo('.howWeWork-card-wrapper', {
				opacity: 0,
				y: '40px',
			  }, {
				y: '0px',
				opacity: 1,
				duration: 0.8,
				stagger: 0.2,
			  });
		  
			imgCards.forEach(imgCard => {
			  cardAnimate.fromTo(imgCard, {
				scale: 1.1,
				duration: 1,
			  }, {
				scale: 1,
				stagger: 0.1,
			  }, '<.1');
			});
		  
			titleCards.forEach(titleCard => {
			  cardAnimate.fromTo(titleCard, {
				scale: 1.1,
				duration: 1,
			  }, {
				scale: 1,
				stagger: 0.1,
			  }, '<.1');
			});
			
		  }
		  
	}, 1300);

	// 
});